<template>
  <div class="loading-state">
    <div class="cosmic-loader"></div>
    <span v-if="label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'LoadingState',
  props: { label: { type: String, default: 'Loading…' } }
}
</script>

<style scoped>
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 56px 20px;
  color: var(--text-secondary);
}
.cosmic-loader {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(var(--primary-rgb), 0.3);
  border-radius: 50%;
  border-top-color: var(--primary-color);
  animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) {
  .cosmic-loader { animation-duration: 2.5s; }
}
</style>
